import React, { Component } from "react";
export default class Header extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <React.Fragment>
        {/*generated code*/}
        <header id="home">
          <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
              Show navigation
            </a>
            <a className="mobile-btn" href="#" title="Hide navigation">
              Hide navigation
            </a>
            <ul id="nav" className="nav">
              <li className="current">
                <a className="smoothscroll" href="#home">
                  Home
                </a>
              </li>
              <li>
                <a className="smoothscroll" href="#about">
                  About
                </a>
              </li>
              {/* <li>
                <a className="smoothscroll" href="#resume">
                  Resume
                </a>
              </li> */}
              {/* <li>
                <a className="smoothscroll" href="#portfolio">
                  Projects
                </a>
              </li> */}
              {/* <li>
                <a className="smoothscroll" href="#testimonials">
                  Testimonials
                </a>
              </li> */}
              {/* <li>
                <a className="smoothscroll" href="#contact">
                  Contact
                </a>
              </li> */}
            </ul>{" "}
            {/* end #nav */}
          </nav>{" "}
          {/* end #nav-wrap */}
          <div className="row banner">
            <div className="banner-text">
              <h1 className="responsive-headline">{resumeData.name}</h1>
              <h3>
                I am a developer, teacher, and life long learner who is
                passionate about community and technology. Let's start creating{" "}
                <a className="smoothscroll" href="#about">
                  together
                </a>
                .
              </h3>
              <hr />
              <ul className="social">
                <li>
                  <a
                    href={resumeData.linkedin}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <i className="fa fa-linkedin" />
                  </a>
                </li>
                <li>
                  <a
                    href={resumeData.instagram}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <i className="fa fa-instagram" />
                  </a>
                </li>
                <li>
                  <a
                    href={resumeData.github}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <i className="fa fa-github" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <p className="scrolldown">
            <a className="smoothscroll" href="#about">
              <i className="icon-down-circle" />
            </a>
          </p>
        </header>
      </React.Fragment>
    );
  }
}
